import sliceCreator from '../../index.jsx';
import {GET_POST_SEASON_ACTIVITY_BY_ID} from '../../../constants/index.jsx';
const _getPostSeasonActivityByIdAction = sliceCreator('GET_POST_SEASON_ACTIVITY_BY_ID', GET_POST_SEASON_ACTIVITY_BY_ID, 'get');

const { asyncAction: getPostSeasonActivityByIdAction, reducer, clearData: clearGetPostSeasonActivityByIdAction } = _getPostSeasonActivityByIdAction;

export default reducer;

export {
    getPostSeasonActivityByIdAction,
    clearGetPostSeasonActivityByIdAction
}